<template>
  <BaseModal v-model:is-open="isOpen" :z-index="9999">
    <template #title>
      <div class="d-flex justify-center align-center text-danger title-font">
        <img
          src="~/assets/images/icons/ic_error.png"
          class="mr-3 icons"
        />
        エラー
      </div>
    </template>
    <template #contents>
      <div>画面ID: {{ displayId }}</div>
      <div>エラーコード: {{ errorCode }}</div>
      <div class="mt-5">
        <span class="body-font">{{ message }}</span>
      </div>
    </template>
    <template #actionButtons>
      <CustomButton width="100%" @click="close">
        OK
      </CustomButton>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '../base/BaseModal.vue';
import CustomButton from '~/components/common/parts/CustomButton.vue';

const isOpen = defineModel<boolean>('isOpen');

defineProps<{
  displayId: string;
  errorCode: string;
  message: string;
}>();

const emits = defineEmits(['close']);

const close = () => {
  isOpen.value = false;
  emits('close');
};
</script>

<style lang="scss" scoped>
.title-font {
  font-size: 1.5rem !important;
  font-weight: bold;
}

.body-font {
  font-size: 1.25rem !important;
  font-weight: 300;
}

.z-index-max {
  z-index: 9999 !important;
}

.icons {
  width: 1.5rem;
  height: 1.5rem;
}
</style>
